import React from "react";
import Link from "next/link";
import { HealthAndSafety } from "@mui/icons-material";

interface InactiveAccountProps {
  className?: string;
}

export default function InactiveAccount({ className = "" }: InactiveAccountProps) {
  return (
    <div className={`min-h-screen bg-gradient-to-br from-slate-900 via-sky-900 to-slate-900 flex items-center justify-center p-4 ${className}`}>
      <div className="max-w-md w-full backdrop-blur-xl bg-white/10 rounded-3xl border border-white/20 p-8 shadow-2xl">
        <div className="text-center">
          <div className="text-red-400 mb-6">
            <div className="w-20 h-20 bg-red-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <HealthAndSafety className="w-10 h-10 text-red-400" />
            </div>
            <h2 className="text-red-400 text-2xl font-bold">
              Account Deactivated
            </h2>
          </div>
          <p className="text-gray-300 mb-6 leading-relaxed">
            Your profile and your information will be permanently deleted
            30 days after your deletion request. It can take up to 90 days
            to delete all your content, but it won't be visible to other
            users during this time.
          </p>
          <p className="text-gray-300 mb-6">Please contact to support@yupmedi.com to reactivate.</p>
          <Link href={"/"} className="inline-block bg-gradient-to-r from-sky-500 to-sky-600 text-white px-6 py-3 rounded-xl font-semibold hover:from-sky-600 hover:to-sky-700 transition-all duration-300 transform hover:scale-105">
            Visit Home
          </Link>
        </div>
      </div>
    </div>
  );
}
